import { render, staticRenderFns } from "./referral-request.vue?vue&type=template&id=399dd7ea&scoped=true&"
import script from "./referral-request.vue?vue&type=script&lang=js&"
export * from "./referral-request.vue?vue&type=script&lang=js&"
import style0 from "./referral-request.vue?vue&type=style&index=0&id=399dd7ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399dd7ea",
  null
  
)

export default component.exports